import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

class ContactPost extends React.Component {

  render() {

    const { data } = this.props;

    return (
      <React.Fragment>
        <div className="row flotiq-rich-text-wrap">

          <div className="text-center"><h1>{data.data.contact.heading}</h1></div>
          <section dangerouslySetInnerHTML={{ __html: data.data.contact.content}} />

{/*          {data.data.allPage.nodes.map(items => (
            <div className="Catalogue__item col-sm-12 col-md-6 col-lg-4" key={items.id}>
              <div className="details_List">

                <Link to={`/${items.slug}`}>

                  { items.featured_image ? <Img sizes={{
                      "src": `${'https://api.flotiq.com'}/image/600x0/${items.featured_image[0].id}.${items.featured_image[0].extension}`,
                      "aspectRatio": 1.77,
                      "sizes": '',
                      "srcSet": ''
                  }} /> : <div className="no-image">No Image</div>}

                </Link>


                  <div className="details_inner">

                  <h2>
                    <Link to={`/${items.slug}`}>{items.name}</Link>
                  </h2>
                </div>
              </div>
            </div>
          ))}*/}


        </div>
      </React.Fragment>
    );
  }
}

const ContactPage = data => (

  <Layout>

    <SEO
      title="Contact" 
      ogTitle="Contact" 
      ogURL="https://choflyelite-legacy.netlify.com/contact"
      ogDescription={data.data.contact.heading}
      ogImage={data.data.contact.featured_image ? `${'https://api.flotiq.com'}/image/0x0/${data.data.contact.featured_image[0].id}.${data.data.contact.featured_image[0].extension}` : ""}
      ogImageSecure={data.data.contact.featured_image ? `${'https://api.flotiq.com'}/image/0x0/${data.data.contact.featured_image[0].id}.${data.data.contact.featured_image[0].extension}` : ""}
      keywords={['Chofly Elite', 'ChoseN', 'Raid', 'Raid Shadow Legends', 'Twitch Streamer', 'YouTuber', 'Content Creator', 'YouTube Content Creator', 'Plarium Moderator',]}
    />
    <div className="contact-page page">
        <div className="container">
        <div className="row">
            <div className="col-sm-12 center">
              <ContactPost data={data} />
              <form name="Contact Form" method="POST" data-netlify="true">
                  <input type="hidden" name="form-name" value="Contact Form" />
                <p>
                  <input type="text" name="name" placeholder="Name" />
                </p>
                <p>
                  <input type="email" name="email" placeholder="Email" />
                </p>
                <p>
                  <textarea name="message" id="message" class="c-input-field c-input-field--multiline" placeholder="Message"></textarea>
                </p>
                <p>
                  <button type="submit">Send</button>
                </p>
              </form>
            </div>
            </div>
        </div>
    </div>

  </Layout>
)

export default ContactPage

export const query = graphql`
    query ContactPageQuery {

      contact {
        heading
        content
        featured_image {
          id
          fileName
          extension
        }
      }

  }

`